import { createReducer } from '@reduxjs/toolkit'

import { ObjectSizeMappingsRedux } from 'types/GlobalNormalizedRent'

import * as actions from '../../../actions/internal/ObjectSizeMapper/actions'
import * as authenticationActions from '../../../actions/Authentication/actions'

const INITIAL_STATE: ObjectSizeMappingsRedux = {}

const ObjectSizeMapperReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getObjectSizeMappingsSuccess, (state, action) => {
      const { customerId, mappings } = action.payload

      return { ...state, [customerId]: mappings }
    })
    .addCase(actions.createObjectSizeMappingSuccess, (state, action) => {
      const mapping = action.payload
      const current = state[mapping.customer_id] ?? []

      return { ...state, [mapping.customer_id]: [...current, mapping] }
    })
    .addCase(actions.deleteObjectSizeMappingSuccess, (state, action) => {
      const { customerId, mappingId } = action.payload
      const current = (state[customerId] ?? []).filter(
        (m) => m.id !== mappingId
      )

      return { ...state, [customerId]: current }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default ObjectSizeMapperReducer
